// extracted by mini-css-extract-plugin
module.exports = {"root":"FilterClinic_root__2Ib_g"};